<template>
  <div>
    <div class="brand-logo">
      <BrandLogo
        name="International Musical"
        :logo="require('../../../assets/brands_logo_2_big.png')"
      ></BrandLogo>
    </div>
    <BrandIntro class="brand-intro" :lineArray="array"></BrandIntro>
    <div class="products">
      <div class="products__block">
        <div class="products__block__title">Performance</div>
        <img
          class="products__block__img"
          src="../../../assets/brands_image_4.png"
        />
      </div>
    </div>
  </div>
</template>
<script>
import BrandLogo from "./BrandLogo";
import BrandIntro from "./BrandIntro"
export default {
  data() {
    return {
      array: [
        "Kicking off from Broadway musicals investment, ACO Musical has invested and co-produced 28 Broadway musicals, wining 20 Tony Awards and 62 nominations since 2015.",
        "Since 2017, ACO Musical started bringing world-class musicals to China, such as the Broadway classic Wicked, CATS, Evita, RENT, and the French musical Romeo & Juliette. In 2020, ACO will present the phenomenal Broadway musical Come From Away.",
        "In 2018, the Chinese Version of Daddy Long Legs, I DO! I DO!, Midnight Diner produced and presented by ACO Musical have toured over and moved 12 cities.  2019, the revivals of those musicals are coming back with better interpretation, and more Chinese version productions such as First Date, In Transit will be produced in 2020.",
        "In 2018, ACO Musical presented 475 performances in 14 cities in China.",
        "In 2019, ACO Musical will present full-heartedly Andrew Lloyd Webber’s classic Evita, and will for the very first time expand internationally by producing the popular French musical Le Rouge et Noir: L‘Opera Rock.",
        "In order to nurture more local musical talents, ACO Musical has created a scheme for original musicals. In 2019, a group of new original musicals, including Bring My Brother Away - adapted from a popular Manga, will be presented."
      ]
    };
  },
  components: {
    BrandLogo,
    BrandIntro
  }
};
</script>
<style lang="scss" scoped>
.brand-logo {
  padding: 64px 0 54px 0;
  text-align: center;
}
.brand-intro{
  width: 1200px;
  margin: 0 auto;
}
.products {
  height: 712px;
  background-color: #1f1f1f;
  overflow: hidden;
  &__block {
    &__title {
      color: #ec6900;
      text-align: center;
      font-size: 30px;
      font-weight: bold;
      font-size: 26px;
      margin-top: 58px;
    }
    &__img {
      display: block;
      margin: 31px auto 0 auto;
    }
  }
}
</style>